import React, { useEffect } from 'react'
import styles from "../RecipientList.styles"

import ConfirmationPopup from '../../../../components/popup/confirmationpopup/ConfirmationPopup'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import { BUTTON_TYPE } from '../../../../components/button/constants'

import { componentKey, setBuyingPlan, setEstimedTaxModalOpen, setFirstConfirmationModalOpen, setIsSelectAll, setPayWithPaymentModalOpen, setPayWithPrepayModalOpen, setPrepayRequestFieldsTouch, setPrepayRequestModalOpen, setPrepayRequests, setRecipientEmail, setSecondRequestedCountModalOpen, setShowContactUsModal, setShowUpdateRecipientEmailModal, setThirdProceedWithW9RequestModalOpen } from "./BulkW9RequestModalSlice"
import { componentKey as recipentSectionSliceComponentKey } from "../../RecipientsSectionSlice"
import { componentKey as recipientsListcomponentKey, setIsUpdateEmailSuccess, setShouldReloadPaginatedRecipientList } from "../RecipientListSlice"
import { useDispatch, useSelector } from 'react-redux'
import { getW9Fees, getW9RequestedCount, isDisplayPlansView, requestBulkW9 } from './BulkW9RequestModalSaga'
import { FIELDS_TEXTS, RECIPIENT_LISTING_LOADING_STATES, W8W9_REQUESTS_PLANS, W8W9_REQUESTS_PLAN_E } from '../constants'
import GetW8FormsModal from '../bulkw8requestmodals/bulkw8requestcustommodals/GetW8FormsModal'
import GeneralValidator, { generalValidator } from '../../../../../libs/utility/validators/GeneralValidator'
import General from '../../../../../libs/utility/General'
import RecipientDataService from '../../../../../services/RecipientDataService'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../../components/paymentdrawer/constants'
import PaymentDrawer from '../../../components/paymentdrawer/PaymentDrawer'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../../components/toast/constants'
import Loadable from '../../../../components/loadable/Loadable'
import { W9_MODALS_LOADING_STATES, W9_MODALS_MESSAGE_MAP } from './constants'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import InformationPopup from '../../../../components/popup/informationpopup/InformationPopup'
import TextInput from '../../../../components/input/textinput/TextInput'
import { updateRecipientEmail } from '../RecipientListSaga'

const BulkW9RequestModals = () => {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();

    const { loadingState, first_confirmationModalOpen, second_requestedCountModalOpen, third_proceedWithW9RequestModalOpen, requestedCount, prepayRequestsInformation, prepayRequestModalOpen, payWithPrepayModalOpen, paymentInformation, buyingPlan, w9Fees, isSelectAll, hasEnoughRequests, showUpdateRecipientEmailModal, RecipientEmail, showContactUsModal } = useSelector(state => state[componentKey]);

    const { selectedPayer } = useSelector(state => state[recipentSectionSliceComponentKey]);

    const { loadingState: recipientListLoadingState, selectedRecipients, recipientList, highlightedRecipient, isUpdateEmailSuccess } = useSelector(state => state[recipientsListcomponentKey]);

    const { REQUEST_BULK_W9_LOADING, DISPLAY_PLANS_VIEW_LOADING, GET_W9_REQUEST_COUNT_LOADING } = W9_MODALS_LOADING_STATES;

    const RecipientIds = selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId];

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setRecipientEmail({ value, errors, rules }));
        }
        else {
            dispatch(setRecipientEmail({ value }));
        }
    };


    useEffect(() => {
        if (isUpdateEmailSuccess) {
            dispatch(setShowUpdateRecipientEmailModal(false))
            dispatch(setIsUpdateEmailSuccess(false))
        }
    }, [isUpdateEmailSuccess])


    return (
        <Loadable
            currentState={loadingState?.state}
            loadingStates={[REQUEST_BULK_W9_LOADING, DISPLAY_PLANS_VIEW_LOADING, GET_W9_REQUEST_COUNT_LOADING]}
            isNewLoadable={true}
            preserveChildMount={true}
            messageMap={W9_MODALS_MESSAGE_MAP}
        >

            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Do you want to W9 Request all recipients under selected payer or W9 Request only selected recipients ?'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={first_confirmationModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: RecipientIds, IsAllSelect: true }
                        dispatch(getW9RequestedCount(data));
                        dispatch(setIsSelectAll(true))
                    },
                    confirmationButtonText: "W9 Request All Recipients",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        let data = { PayerID: selectedPayer.PayerDetailId, RecipientIds: RecipientIds, IsAllSelect: false }
                        dispatch(getW9RequestedCount(data));
                        dispatch(setIsSelectAll(false))
                    },
                    onCloseCb: () => {
                        dispatch(setFirstConfirmationModalOpen(false))
                    },
                    cancelButtonText: "W9 Request Selected Recipients",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                isClose={false}
                customStyle={styles.tinMatchPopup}
            />

            <ConfirmationPopup title='Are you sure?'
                bodyText={`A W9 request has been submitted for ${requestedCount.bulkW9Requests || 0} recipients and ${requestedCount.AcceptedW9Requests || 0} Accepted W9 requests recipients.`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={second_requestedCountModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        if (requestedCount.bulkW9Requests == 1 && !General.arrayObjectsKeyIsNotEmpty(selectedRecipients.length ? selectedRecipients : [highlightedRecipient], FIELDS_TEXTS.EMAIL_ID_TEXT)) {
                            dispatch(setShowUpdateRecipientEmailModal(true))
                        }else if (requestedCount.bulkW9Requests !== 0) {
                            dispatch(isDisplayPlansView({ RecipientIds, isSelectAll }));
                            dispatch(getW9Fees({ count: requestedCount?.bulkW9Requests }));
                            dispatch(setSecondRequestedCountModalOpen(false))
                        } else {
                            dispatch(addNotifications({ heading: "Error", message: "W9 request count should be greater than 0." }));
                            dispatch(setSecondRequestedCountModalOpen(false))
                        }
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setSecondRequestedCountModalOpen(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
            />

            <ConfirmationPopup
                title='Are you sure?'
                bodyText='Click on proceed to continue sending bulk W9 requests'
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={third_proceedWithW9RequestModalOpen}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        if (hasEnoughRequests) {
                            const data = {
                                RecipientIds: selectedRecipients?.length ? selectedRecipients.map(item => item.RecipentDetailId) : [highlightedRecipient?.RecipentDetailId],
                                totalAmount: w9Fees,
                                prepay: "Yes",
                                isPrepaid: "true",
                                selectAll: isSelectAll,
                                isAccountant: "true",
                                placeOfOriginforpayment: selectedRecipients.length > 1 ? PLACE_OF_ORIGIN_FOR_PAYMENT.BULK_W8_W9_PAYMENT : PLACE_OF_ORIGIN_FOR_PAYMENT.SINGLE_W8_W9_PAYMENT,
                                PayerId: selectedPayer.PayerDetailId,
                                payerId: selectedPayer.PayerDetailId,
                                FormType: "W9",
                                isW8orW9Payment: "W9"
                            }
                            dispatch(requestBulkW9(data));
                        } else {
                            dispatch(setThirdProceedWithW9RequestModalOpen(false))
                            dispatch(setPayWithPrepayModalOpen(true));
                        }
                    },
                    confirmationButtonText: "Proceed",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setThirdProceedWithW9RequestModalOpen(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                loadingState={loadingState?.state}
                loaderLoadingStates={[W9_MODALS_LOADING_STATES.GET_W9_FEES_LOADING]}
            />

            <GetW8FormsModal
                title="Get Prepay Requests"
                isOpen={prepayRequestModalOpen}
                bodyText="You don't have any prepay requests. Click on OK to process W8/W9 requests."
                confirmationButtonProps={{
                    onConfirmationCb: () => {

                        dispatch(setPrepayRequestFieldsTouch(true))
                        if (!GeneralValidator.validateRequiredFields(prepayRequestsInformation)) {
                            if(prepayRequestsInformation?.prepayRequests?.value === W8W9_REQUESTS_PLAN_E){
                                dispatch(setShowContactUsModal(true))
                            }else{
                                dispatch(setPayWithPrepayModalOpen(true))
                            }
                            dispatch(setPrepayRequestModalOpen(false))
                        }
                    },
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => {
                        dispatch(setPrepayRequestModalOpen(false))
                    },
                    onCloseCb: () => {
                        dispatch(setPrepayRequestModalOpen(false))
                    },
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                value={{ label: prepayRequestsInformation?.prepayRequests?.label, value: prepayRequestsInformation?.prepayRequests?.value }}
                rules={prepayRequestsInformation.prepayRequests.rules}
                errors={prepayRequestsInformation.prepayRequests.errors}
                formSubmitted={prepayRequestsInformation.allRequiredFieldsTouched}
                name="prepayRequests"
                placeHolder="Select plan type"
                isClose={false}
                onSelectCb={(name, selectedOption) => dispatch(setPrepayRequests({ [name]: selectedOption }))}
                options={W8W9_REQUESTS_PLANS}
            />

            {payWithPrepayModalOpen &&
                <PaymentDrawer
                    isOpen={payWithPrepayModalOpen}
                    onCloseCb={() => dispatch(setPayWithPrepayModalOpen(false))}
                    fees={{
                        OnlySeparateStatefiling: "false",
                        TotalFilingFee: buyingPlan ? prepayRequestsInformation?.prepayRequests?.price : w9Fees,
                        FilingFee: buyingPlan ? prepayRequestsInformation?.prepayRequests?.price : w9Fees,
                        USPSFee: "0",
                        TINMatchFee: "0",
                        StateFee: "0",
                        TINCount: "0",
                        StateFilingCount: "0",
                        USPSCount: "0",
                        FormCount: "0"
                    }}
                    filingFeeLabel={`W-9 Request Fee`}
                    calculatePrepaySalesTax={true}
                    paymentServiceFunctionCb={RecipientDataService.requestBulkW9}
                    onPaymentSuccessCb={() => {
                        dispatch(setShouldReloadPaginatedRecipientList(true))
                        dispatch(addNotifications({ heading: "Success", message: "W-9 Request Successful", variant: TOASTER_VARIANT.SUCCESS }))
                    }}
                    placeOfOriginforpayment={buyingPlan ? PLACE_OF_ORIGIN_FOR_PAYMENT.MR_W8_W9_PAYMENT : selectedRecipients.length > 1 ? PLACE_OF_ORIGIN_FOR_PAYMENT.BULK_W8_W9_PAYMENT : PLACE_OF_ORIGIN_FOR_PAYMENT.SINGLE_W8_W9_PAYMENT}
                    paymentServiceFunctionExtraParams={{
                        RecipientIds: RecipientIds,
                        selectAll: isSelectAll,
                        isAccountant: "false",
                        PayerId: selectedPayer.PayerDetailId,
                        payerId: selectedPayer.PayerDetailId,
                        payeeName: paymentInformation?.Name?.value,
                        isW8orW9Payment: "W9",
                        w8W9PlanType: buyingPlan ? prepayRequestsInformation.prepayRequests?.value : "",
                        FormType: buyingPlan ? "" : "W9",
                    }}
                />
            }

            {showUpdateRecipientEmailModal ?
                <InformationPopup
                    title={"Recipient email address does not exists. Update email and send request."}
                    isOpen={showUpdateRecipientEmailModal}
                    confirmationButtonProps={{
                        onConfirmationCb: () => {
                            const errors = GeneralValidator.validateRequiredFields({ RecipientEmail })
                            if (!errors) {
                                dispatch(isDisplayPlansView({ RecipientIds, isSelectAll }));
                                dispatch(getW9Fees({ count: requestedCount?.bulkW9Requests }));
                                dispatch(setSecondRequestedCountModalOpen(false))
                                dispatch(updateRecipientEmail({ PayeeEmail: RecipientEmail?.value, PayeeID: RecipientIds.length ? RecipientIds[0] : "" }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please enter valid data" }))
                            }
                        },
                        confirmationButtonText: "Ok",
                        confirmationButtonStyles: {},
                        confirmationButtonType: BUTTON_TYPE.PRIMARY,
                    }}
                    showClose={true}
                    onCloseCb={() => dispatch(setShowUpdateRecipientEmailModal(false))}
                    loadingState={recipientListLoadingState}
                    loaderLoadingStates={[RECIPIENT_LISTING_LOADING_STATES.UPDATE_RECIPIENT_EMAIL_LOADING]}
                >
                    <TextInput
                        name="RecipientEmail"
                        type="email"
                        label="Email address"
                        placeHolder='abc@example.com'
                        value={RecipientEmail?.value}
                        onChangeCb={onChangehandler}
                        rules={RecipientEmail?.rules}
                        errors={RecipientEmail.errors}
                    />

                </InformationPopup> : null
            }
            { showContactUsModal && <ConfirmationPopup title='Contact Us'
                bodyText={`Please contact us for pricing`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={showContactUsModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(setShowContactUsModal(false))
                    },
                    confirmationButtonText: "Ok",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={null}
                showClose={false}
            />
            }

        </Loadable>
    )
}

export default BulkW9RequestModals
